// extracted by mini-css-extract-plugin
export default {"input":"CustomInputNumber_input__s4wI6"};